import { useLang } from '../../i18n/LanguageContext';

export const LanguageSwitcher = ({ className = '' }) => {
  const { lang, setLang } = useLang();
  return (
    <div className={`inline-flex items-center text-xs font-bold uppercase tracking-widest ${className}`} data-testid="language-switcher">
      <button
        onClick={() => setLang('en')}
        className={lang === 'en' ? 'text-gold' : 'text-white/45 hover:text-white/80 transition-colors'}
        data-testid="lang-en"
        aria-pressed={lang === 'en'}
      >
        EN
      </button>
      <span className="mx-1.5 text-white/25">|</span>
      <button
        onClick={() => setLang('tr')}
        className={lang === 'tr' ? 'text-gold' : 'text-white/45 hover:text-white/80 transition-colors'}
        data-testid="lang-tr"
        aria-pressed={lang === 'tr'}
      >
        TR
      </button>
    </div>
  );
};
